(() => {
  if (window.__izziProductReveal) return;
  window.__izziProductReveal = true;
  const instances = new Map();
  function init(root) {
    root.querySelectorAll('[data-izzi-product]').forEach(section => {
      if (instances.has(section)) return;
      const overlay=section.querySelector('[data-izzi-overlay]');
      const box=section.querySelector('[data-izzi-video-box]');
      const template=box?.querySelector('[data-izzi-video-template]');
      const video=box && (box.querySelector('video') || (template && document.createElement('video')));
      let hydrated=false;
      if (video && !video.parentNode) box.append(video);
      const skip=section.querySelector('[data-izzi-skip]');
      const replay=section.querySelector('[data-izzi-replay]');
      const content=section.querySelector('product-component');
      if(!video || !content || !overlay || !skip || !replay) return;
      const mobile=matchMedia('(max-width: 749px)');
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      let state='idle', timer, transition, fade, disposed=false, generation=0;
      const clear=()=>{clearTimeout(timer);};
      function unlock() {content.inert=false;content.removeAttribute('aria-hidden');}
      function complete() {
        clear(); video.pause(); overlay.hidden=true;unlock();
        section.classList.remove('izzi-intro-active','izzi-intro-settling');
        transition?.cancel();fade?.cancel();transition=null;fade=null;
        replay.hidden=mobile.matches;state='done';
      }
      async function finish(animate=true) {
        if(state!=='playing')return;
        state='settling';clear();video.pause();
        const focusWasInside=overlay.contains(document.activeElement);
        section.classList.add('izzi-intro-settling');
        const target=section.querySelector('.product__media-wrapper .product__media') || section.querySelector('.product__media-wrapper');
        if(animate && !reduced.matches && target && box.animate) {
          const from=box.getBoundingClientRect(),to=target.getBoundingClientRect();
          if(from.width && from.height && to.width && to.height) {
            box.style.transformOrigin='top left';
            const scale=Math.min(to.width/from.width,to.height/from.height);
            const dx=to.left+(to.width-from.width*scale)/2-from.left;
            const dy=to.top+(to.height-from.height*scale)/2-from.top;
            transition=box.animate([
              {transform:'translateX(-50%)'},
              {transform:`translateX(-50%) translate(${dx}px, ${dy}px) scale(${scale})`}
            ],{duration:750,easing:'cubic-bezier(.22,.61,.36,1)',fill:'forwards'});
            // Reveal the native gallery and story underneath, with no second page/scroll.
            fade=overlay.animate([{opacity:1},{opacity:1,offset:.55},{opacity:0}],{duration:900,fill:'forwards'});
            try {await fade.finished;} catch (_) {}
          }
        }
        if(disposed)return;
        complete();
        if(focusWasInside)replay.focus({preventScroll:true});
      }
      function fallback(){finish(false);}
      function arm(){clear();timer=setTimeout(fallback,8000);}
      async function start(manual=false) {
        if(disposed)return;
        if(mobile.matches || (reduced.matches && !manual)){complete();return;}
        if (template && !hydrated) {
          const source=template.content.querySelector('video');
          if (!source) {complete();return;}
          for (const attribute of source.attributes) video.setAttribute(attribute.name,attribute.value);
          video.replaceChildren(...Array.from(source.childNodes, node => node.cloneNode(true)));
          hydrated=true;
        }
        const run=++generation;
        clear();transition?.cancel();fade?.cancel();
        state='playing';overlay.hidden=false;replay.hidden=true;
        section.classList.remove('izzi-intro-settling');section.classList.add('izzi-intro-active');
        content.inert=true;content.setAttribute('aria-hidden','true');
        video.muted=true;video.playsInline=true;
        try {video.currentTime=0;} catch (_) {}
        arm();
        try {await video.play();} catch (_) {if(run===generation)fallback();}
      }
      const onSkip=()=>finish(false),onEnd=()=>finish(true),onTime=()=>{if(state==='playing')arm();};
      const onReplay=()=>start(true),onPageShow=e=>{if(e.persisted)complete();};
      video.addEventListener('ended',onEnd);video.addEventListener('error',fallback);
      video.addEventListener('timeupdate',onTime);video.addEventListener('waiting',arm);
      skip.addEventListener('click',onSkip);replay.addEventListener('click',onReplay);
      window.addEventListener('pageshow',onPageShow);
      const onMobileChange=()=>{if(mobile.matches){generation++;complete();}else{replay.hidden=false;}};
      mobile.addEventListener('change',onMobileChange);
      instances.set(section,()=>{disposed=true;generation++;complete();mobile.removeEventListener('change',onMobileChange);video.removeEventListener('ended',onEnd);video.removeEventListener('error',fallback);video.removeEventListener('timeupdate',onTime);video.removeEventListener('waiting',arm);skip.removeEventListener('click',onSkip);replay.removeEventListener('click',onReplay);window.removeEventListener('pageshow',onPageShow);});
      // Keep the editor easy to work in; merchant can replay on demand.
      if(window.Shopify && window.Shopify.designMode)complete();else start();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{for(const [s,cleanup] of instances)if(e.target.contains(s)){cleanup();instances.delete(s);}});
})();
